import React, { useState, useEffect } from "react";
import RedButton from "components/atoms/RedButton/RedButton";
import BorderButton from "components/atoms/BorderButton/BorderButton";
import ButtonsWrapper from "components/molecules/ButtonsWrapper/ButtonsWrapper";
import { RedBar } from "components/atoms/RedBar/RedBar";
import { DarkBar } from "components/atoms/DarkBar/DarkBar";
import { Container } from "components/atoms/Container/Container";
import { Subtitle } from "components/atoms/Subtitle/Subtitle";
import { SelectedChallengesList, EstimatedWrapper } from "views/Step3.styles";
import { InputField } from "components/molecules/InputField/InputField";
import ExampleList from "components/molecules/ExampleList/ExampleList";
import ExampleListData from "data/ExampleListData";
import Step3Data from "data/Step3Data";
import GlobalData from "data/GlobalData";
import CurrencyFormat from "react-currency-format";
const Step3 = ({
  priceValue,
  onHandleNextStep,
  onHandleBackStep,
  step,
  summary,
  priceValidationError,
  setPriceValidationError,
  lang,
}) => {
  const [price, setPrice] = useState(priceValue);
  const handleBack = (step) => {
    onHandleBackStep(step);
  };
  const handleNext = () => {
    onHandleNextStep(price);
  };
  const handleInputChange = (value) => {
    setPrice(value);
    const numericValue = parseFloat(value);
    if (numericValue <= 0) {
      setPriceValidationError({
        error:
          lang === "pl"
            ? GlobalData.validation.zero.pl
            : GlobalData.validation.zero.en,
      });
    } else if (value.trim() === "") {
      setPriceValidationError({
        error:
          lang === "pl"
            ? GlobalData.validation.empty.pl
            : GlobalData.validation.empty.en,
      });
    } else {
      setPriceValidationError({ error: null });
    }
  };
  const handleTipClick = () => {
    const tip = document.querySelector(".price-tip");
    tip.classList.toggle("active");
  };
  useEffect(() => {
    setPrice(priceValue);
  }, [priceValue]);
  return (
    <Container>
      <Subtitle>
        {lang === "pl" ? Step3Data.subtitle.pl : Step3Data.subtitle.en}
      </Subtitle>
      <SelectedChallengesList>
        {summary &&
          summary.map(({ challenge }, index) => (
            <RedBar key={index}>{challenge.name}</RedBar>
          ))}
      </SelectedChallengesList>

      <DarkBar>
        {lang === "pl" ? Step3Data.darkbar.pl : Step3Data.darkbar.en}
      </DarkBar>
      <EstimatedWrapper>
        <InputField column={false}>
          <label>
            {lang === "pl" ? Step3Data.label.pl : Step3Data.label.en}{" "}
            <span onClick={handleTipClick}>?</span>
          </label>

          <CurrencyFormat
            value={price}
            isNumericString={true}
            decimalSeparator=","
            thousandSeparator=" " // Enable thousand separators
            placeholder={
              lang === "pl"
                ? GlobalData.placeholder.number.pl
                : GlobalData.placeholder.number.en
            }
            suffix={lang === "pl" ? " PLN" : " EUR"}
            onValueChange={(values) => {
              const { value } = values;
              handleInputChange(value);
              // Assuming handleInputChange accepts the new formatted value
            }}
          />
          {priceValidationError.error && (
            <p className="error">{priceValidationError.error}</p>
          )}
        </InputField>
        <div
          dangerouslySetInnerHTML={{
            __html: lang === "pl" ? Step3Data.tip.pl : Step3Data.tip.en,
          }}
          className="price-tip"
        ></div>
        <ExampleList ExampleListData={ExampleListData} lang={lang} />
      </EstimatedWrapper>

      <ButtonsWrapper>
        <BorderButton onClick={() => handleBack(step)}>
          {lang === "pl"
            ? GlobalData.buttons.back.pl
            : GlobalData.buttons.back.en}
        </BorderButton>
        <RedButton
          disabled={
            price === "" ||
            Object.keys(priceValidationError).length === 0 ||
            !Object.values(priceValidationError).every((prop) => prop === null)
          }
          onClick={handleNext}
        >
          {lang === "pl"
            ? GlobalData.buttons.next.pl
            : GlobalData.buttons.next.en}
        </RedButton>
      </ButtonsWrapper>
    </Container>
  );
};

export default Step3;
